module.exports = __webpack_public_path__ + "static/media/LATINS_COMMUNS.2b62bc26.jpg";